import { useState, useEffect } from "react";
import {
  isStoryFavorite,
  addFavoriteStory,
  removeFavoriteStory,
} from "../data/storyRepo";

/**
 * Manages favorite state for a story.
 * Returns [isFavorite, toggleFavorite]
 */
export function useFavoriteStory(story, user) {
  const [isFavorite, setIsFavorite] = useState(false);
  const language = "de"; // TEMP

  // check favorite state
  useEffect(() => {
    if (!user?.uid || !story?.id) return;

    let cancelled = false;

    async function check() {
      try {
        const fav = await isStoryFavorite({
          uid: user.uid,
          language,
          storyId: story.id,
        });
        if (!cancelled) setIsFavorite(fav);
      } catch (err) {
        console.error("Error checking favorite:", err);
      }
    }

    check();
    return () => {
      cancelled = true;
    };
  }, [user?.uid, story?.id, language]);

  // toggle favorite
  const toggleFavorite = async () => {
    if (!user?.uid || !story?.id) return;

    try {
      if (isFavorite) {
        await removeFavoriteStory({
          uid: user.uid,
          language,
          storyId: story.id,
        });
        setIsFavorite(false);
      } else {
        await addFavoriteStory({
          uid: user.uid,
          language,
          story,
        });
        setIsFavorite(true);
      }
    } catch (err) {
      console.error("Error toggling favorite:", err);
    }
  };

  return [isFavorite, toggleFavorite];
}
